// InviteFriendContainer.jsx
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as referralSelector from "redux/referral/selectors";
import { clear } from "redux/referral/slice";
import { useNavigate } from "react-router-dom";
import { referralApi } from "redux/referral/api";
import InviteFriend from "components/organisms/InviteFriend";
import * as userSelectors from "redux/user/selectors";
import { makeLangUrl } from "helpers/makeLangUrl";
import useReferralStatus from "hooks/useReferralStatus";

const InviteFriendContainer = () => {
  const { invitationLink, referralList, total, lastPage, enabled } =
    useSelector(referralSelector.all);
  const { referrerBalance } = useSelector(userSelectors.all);

  const [requestReferral] = referralApi.useReferralMutation();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { refetch, isFetching } = referralApi.useReferralListQuery({
    take: 5,
    page: currentPage,
  });

  useReferralStatus();

  useEffect(() => {
    if (!enabled) {
      navigate(makeLangUrl("/"));
    }
  }, [enabled, navigate]);

  useEffect(() => {
    if (enabled && currentPage === 1) {
      refetch();
      const host = `https://${window.location.host}`;
      requestReferral({ host });
    }
  }, [enabled, refetch, requestReferral, currentPage]);

  useEffect(() => {
    setLoading(isFetching);
  }, [isFetching]);

  useEffect(() => {
    return () => {
      dispatch(clear());
    };
  }, [dispatch]);

  const handlePageChange = (selectedItem) => {
    const newPage = selectedItem.selected + 1;
    if (newPage > lastPage || newPage === currentPage) {
      return;
    }

    setCurrentPage(newPage);
  };

  const displayedReferrals = useMemo(() => {
    const startIndex = (currentPage - 1) * 5;
    return referralList.slice(startIndex, startIndex + 5);
  }, [referralList, currentPage]);

  return (
    <InviteFriend
      link={invitationLink}
      amount={referrerBalance}
      listReferral={loading ? [] : displayedReferrals}
      lastPage={lastPage}
      total={total}
      currentPage={currentPage}
      onPageChange={handlePageChange}
      isLoading={loading}
      balance={referrerBalance}
    />
  );
};

export default InviteFriendContainer;
